var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68764 9.06849C4.31391 6.39859 6.39859 4.31391 9.06849 3.68764V3.68764C10.9967 3.23535 13.0033 3.23535 14.9315 3.68764V3.68764C17.6014 4.31391 19.6861 6.39859 20.3124 9.0685V9.0685C20.7646 10.9967 20.7646 13.0033 20.3124 14.9315V14.9315C19.6861 17.6014 17.6014 19.6861 14.9315 20.3124V20.3124C13.0033 20.7646 10.9967 20.7646 9.0685 20.3124V20.3124C6.3986 19.6861 4.31391 17.6014 3.68764 14.9315V14.9315C3.23535 13.0033 3.23535 10.9967 3.68764 9.06849V9.06849Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1618 10.8707C14.9461 11.3726 14.9461 12.6274 14.1618 13.1293L11.5147 14.8233C10.7304 15.3253 9.75 14.6979 9.75 13.694L9.75 10.306C9.75 9.30214 10.7304 8.67473 11.5147 9.17665L14.1618 10.8707Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconVideo);
export default __webpack_public_path__ + "static/media/common_icon_video.d7cb605e3e3f89a490d0d837a5df4237.svg";
export { ForwardRef as ReactComponent };